import { render, staticRenderFns } from "./EditClaim.vue?vue&type=template&id=9657da4e&scoped=true&"
import script from "./EditClaim.vue?vue&type=script&lang=js&"
export * from "./EditClaim.vue?vue&type=script&lang=js&"
import style0 from "./EditClaim.vue?vue&type=style&index=0&id=9657da4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9657da4e",
  null
  
)

export default component.exports